import { App } from 'vue';
import Vue3Toastify, { toast } from 'vue3-toastify';
import { initToastTopLayer } from '@/plugins/toastify/toastTopLayer';

export const DEFAULT_AUTOCLOSE = 3000;

// Positioning (incl. the mobile bottom offset that clears the bottom nav) lives in CSS media queries in src/style.css
const toastifyOptions = {
  autoClose: DEFAULT_AUTOCLOSE,
  clearOnUrlChange: false,
  position: toast.POSITION.BOTTOM_CENTER,
  theme: toast.THEME.DARK,
  closeButton: false,
  hideProgressBar: true,
};

export default function (app: App): void {
  app.use(Vue3Toastify, toastifyOptions);
  initToastTopLayer();
}
